// extracted by mini-css-extract-plugin
module.exports = {"root":"DeleteBtn_root__p6yxJ"};